import React from 'react'
import cx from 'classnames'
import {
  useIsTrackEnabled,
  useIsTrackSwitchedOff,
  useMediaContext,
  VideoTrack
} from '@gopeerproject/web-kit'

import { User, Icon } from '@components/UI'

import { useAuth } from '@hooks'

const PlaygroundParticipant = ({ minimized }) => {
  const { localTracks } = useMediaContext()
  const localAudioTrack = localTracks.find((track) => track.kind === 'audio')
  const localVideoTrack = localTracks.find((track) => track.kind === 'video')

  const isVideoEnabled = !!localVideoTrack
  const isAudioEnabled = useIsTrackEnabled(localAudioTrack)
  const isVideoSwitchedOff = useIsTrackSwitchedOff(localVideoTrack)
  const {
    profile: { image, name }
  } = useAuth()

  return (
    <div
      className={cx('gp-Media-playgroundParticipant', {
        'is-videoOff': !isVideoEnabled || isVideoSwitchedOff
      })}
    >
      <div className='gp-Media-playgroundParticipant-video'>
        {isVideoEnabled && <VideoTrack isLocal track={localVideoTrack} />}
        {(!isVideoEnabled || isVideoSwitchedOff) && (
          <User
            name={name}
            img={image}
            hideName
            size={minimized ? 'larger' : 'gigantic'}
          />
        )}
      </div>
      {minimized && (
        <div className='gp-Media-playgroundParticipant-info'>
          <div>
            {isAudioEnabled ? (
              <Icon name='microphone' />
            ) : (
              <Icon name='microphone off' />
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default PlaygroundParticipant
